export const css = {
    root: '_3U9aWQSs',
    item: '_3kqh0-bH',
    complete: '_3rQkfWWo',
    readtime: '_1svKN9ez',
    indented: '_3yN0I3Z0',
    leaf: '_42WnbpaM',
    leafItem: '_2MEEATqu',
    treeRoot: '_3TLf-k0k',
    treeNode: '_1IIrq3ad',
    contentWrapper: 'B_6a4GyU',
    content: 'AD7ZU4Eg',
    title: '_3JFPGmer',
    expander: '_37C_wsI9',
    video: '_2qvWhsnl',
    ' _key': 'afcpe-theme/afcpe/table-of-contents/toc'
};
export default css;
